module.exports = __webpack_public_path__ + "img/ymc-thumb1.168503b0.png";